import { IVector3, IVector2 } from '@easytwin/runtime';
import { isNil } from './typeGuard';

const EPSILON = 10e-5;

export const isSameNumber = (a: number, b: number) => {
  return Math.abs(a - b) < EPSILON;
};

export function toScaledVec3(newValue: IVector3, oldValue: IVector3): IVector3 {
  let factor = 1;
  if (newValue.x !== oldValue.x) {
    oldValue.x !== 0 && (factor = newValue.x / oldValue.x);
  } else if (newValue.y !== oldValue.y) {
    oldValue.y !== 0 && (factor = newValue.y / oldValue.y);
  } else if (newValue.z !== oldValue.z) {
    oldValue.z !== 0 && (factor = newValue.z / oldValue.z);
  }
  if (oldValue.x === 0 || oldValue.y === 0 || oldValue.z === 0) {
    return newValue;
  }

  return {
    x: oldValue.x * factor,
    y: oldValue.y * factor,
    z: oldValue.z * factor,
  };
}

export function toScaledVec2(newValue: IVector2, oldValue: IVector2): IVector2 {
  let factor = 1;
  if (newValue.x !== oldValue.x) {
    oldValue.x !== 0 && (factor = newValue.x / oldValue.x);
  } else if (newValue.y !== oldValue.y) {
    oldValue.y !== 0 && (factor = newValue.y / oldValue.y);
  }

  return {
    x: oldValue.x * factor,
    y: oldValue.y * factor,
  };
}

export function clamp(num: number, min: number, max?: number) {
  if (isNil(max)) {
    return Math.max(num, min);
  }
  return Math.min(Math.max(num, min), max);
}

export function formatNumber(num: number, decimalPlaces = 2) {
  // 保证小数部分精度
  if (num === undefined) return undefined;
  let [integer, decimal] = num.toFixed(decimalPlaces).split('.');

  // 格式化整数部分（千分位）
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 如果有小数部分，则保留小数部分
  return decimal ? `${integer}.${decimal}` : integer;
}
